<template>
  <div class="wheel-battle-detail-header">
    <div class="sequence-row">
      <span class="sequence-text">场序 {{ displaySequenceNo }}</span>
      <span class="sequence-vline" />
    </div>
    <div class="header-divider" />
    <div class="header-body">
      <div class="type-icon">
        <img
          class="type-icon-img"
          src="https://images.snsports.cn/Fmapyv1dN1-f7Mj4S5iVL2UwnMbb"
          alt=""
        />
      </div>
      <div class="header-info">
        <div class="title">{{ title }}</div>
        <div v-if="groupName" class="group-tag">{{ groupName }}</div>
      </div>
      <div v-if="statusLabel" class="status-tag" :class="statusClass">
        {{ statusLabel }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WheelBattleDetailHeader',
  props: {
    sequenceNo: {
      type: [String, Number],
      default: ''
    },
    title: {
      type: String,
      default: '小组车轮战'
    },
    groupName: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: 'notStarted'
    },
    statusLabel: {
      type: String,
      default: ''
    }
  },
  computed: {
    displaySequenceNo: function () {
      if (this.sequenceNo === '' || this.sequenceNo === null || this.sequenceNo === undefined) {
        return '-'
      }
      var str = String(this.sequenceNo)
      return str.length >= 2 ? str : ('0' + str)
    },
    statusClass: function () {
      if (this.status === 'inProgress') {
        return 'status-in-progress'
      }
      if (this.status === 'ended') {
        return 'status-ended'
      }
      return 'status-not-started'
    }
  }
}
</script>

<style scoped lang="scss">
.wheel-battle-detail-header {
  background: #fff;
}

.sequence-row {
  display: flex;
  align-items: center;
  padding: 14px 16px 12px;
}

.sequence-text {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  line-height: 1.4;
}

.sequence-vline {
  width: 1px;
  height: 16px;
  background: #e5e5e5;
  margin-left: 12px;
}

.header-divider {
  height: 1px;
  background: #f0f0f0;
  margin: 0 16px;
}

.header-body {
  display: flex;
  align-items: center;
  padding: 14px 16px 16px;
}

.type-icon {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  margin-right: 12px;
}

.type-icon-img {
  width: 34px;
  height: 34px;
  display: block;
}

.header-info {
  flex: 1;
  min-width: 0;
}

.title {
  font-size: 15px;
  font-weight: 500;
  color: #333;
  line-height: 1.4;
  margin-bottom: 6px;
}

.group-tag {
  display: inline-block;
  padding: 2px 8px;
  font-size: 12px;
  line-height: 18px;
  color: #2071b9;
  background: #e6f1fc;
  border-radius: 4px;
}

.status-tag {
  flex-shrink: 0;
  padding: 4px 10px;
  font-size: 12px;
  line-height: 18px;
  border-radius: 4px;
  margin-left: 8px;
}

.status-not-started {
  background: #f5f5f5;
  color: #999999;
}

.status-in-progress {
  background: #e6f1fc;
  color: #2071b9;
}

.status-ended {
  background: #f5f5f5;
  color: #666666;
}
</style>
